import { Card } from '@radix-ui/themes';
import { PresetTrainingContext } from 'components/machine/dialogs/preset-training/context';
import { PTDetectionFailureCallout } from 'components/machine/dialogs/preset-training/controls/detection-failure-callout';
import { PTSeekFailureCallout } from 'components/machine/dialogs/preset-training/controls/seek-failure-callout';
import { PTStatusBar } from 'components/machine/dialogs/preset-training/controls/status-bar';
import { TrainingContext } from 'contexts/training.context';
import { ProgressDirection, PTStep } from 'enums/training.enums';
import { clamp } from 'lodash';
import { useContext } from 'react';

// either the status bar or the failure callout
export const PresetTrainingStatus = (props: {
  isLastPitch: boolean;
  onFailureRetrain: () => void;
  onFailureContinue: () => void;
  onSuccessChangePitch: (delta: ProgressDirection) => void;
  onSuccessFinish: () => void;
}) => {
  const { shots, warnFailure } = useContext(TrainingContext);

  const {
    active: activeMode,
    iAdjustment,
    showFailure,
    step,
    setStep,
  } = useContext(PresetTrainingContext);

  if (showFailure) {
    return (
      <PTSeekFailureCallout
        onRetrain={props.onFailureRetrain}
        onContinue={props.onFailureContinue}
      />
    );
  }

  if (warnFailure) {
    return <PTDetectionFailureCallout />;
  }

  return (
    <Card>
      <PTStatusBar
        iteration={clamp(iAdjustment, 0, activeMode.spec.maxAdjustments) + 1}
        step={step}
        shots={shots}
        totalShots={Math.max(shots.length, activeMode.spec.maxSamples)}
        isLastPitch={props.isLastPitch}
        changePitch={props.onSuccessChangePitch}
        onFinish={props.onSuccessFinish}
        beforeFire={(_, isReady) => {
          if (isReady) {
            setStep(PTStep.Waiting);
          }
        }}
        onFailedToFire={() => {
          // reset the step to firing so user can try again
          setStep(PTStep.Firing);
        }}
      />
    </Card>
  );
};
